export const QUERY_PARAMS = {
    SALE_YEAR: 'saleYear',
    SALE_NUMBER: 'saleNumber',
    LANE_NUMBER: 'laneNumber',
    SELLER_NUMBER: 'sellerNumber',
    SEARCH_KEYWORDS: 'searchKeywords'
}